import React, {
	FunctionComponent,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/reducers/index";
import { useParams, useHistory } from "react-router-dom";
import config, { path, domain } from "../../config/enviroment";
import useView from "../../hooks/useView";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import { Close } from "../../components/MainModal/Close";
import { Button, withStyles, InputAdornment } from "@material-ui/core";
import AccountCircle from "@material-ui/icons/AccountCircle";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import InfoIcon from "@material-ui/icons/Info";
import { v4 as uuid } from "uuid";
import Checkbox from "../../components/CheckBox";
import { termsConditions } from "../../redux/actions/termsActions";
import { CartPaymentButton } from "../../components/CartTotalSummary/style";
import Spinner from "../../components/Spinner";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import {
	handleSearchBuyer,
	handleLoadingInfo,
	handleResetDetails
} from "../../redux/actions/shippingDetailsActions";

import {
	SpanOne,
	SpanTwo,
	LoadContainer,
	DivForSpan1,
	DetailsForm,
	FifthDivForm,
	SecondSelectForm,
	FirstSelectForm,
	ThirdSelectForm,
	PhoneInput,
	SecondDivForm,
	SecondParragraph,
	ContainerInputEmail,
	MainHeadingForm,
	NameInput,
	FormContainer,
	TitleSummaryCart,
	CountrySelectForm,
	StyledTextField,
	ContainerAuthorize,
	ContainerNote,
	ReturnLinkContainer,
	AddresInfoContainer,
} from "./style";

import "./style.css";
import { handleIdentifyShoppingCart } from "../../redux/actions/shoppingCartActions";
import {
	handleGetCities,
	handleGetCountries,
	setRoute,
} from "../../redux/actions";
import {
	handleLoadDepartaments,
	handleLoadCities,
	handleOnchangeDefaultCity,
	handleToggleCityChangeModalAlert,
	handleToggleCityChangeAlert,
} from "../../redux/actions";
import { CityChangeAlert } from "../../components/CityChangeAlert";
import { CustomIcon } from "../../components/CustomIcon";
import { formatNameCity } from "../../utils/formatData";
import { AddMoreProducts } from "../../components/CartTotalSummary";
import { language } from "../../utils/language";
import useDocumentTypes from "../../hooks/useDocumentTypes";
import MarcaBlancaAddressConfirmModal from "../../components/MarcaBlancaAddressConfirmModal";
import MarcaBlancaTamperModal from "../../components/MarcaBlancaTamperModal";



type AnddressInfoProps = {
	color: string;
	isValidForm: boolean;
	successInfo: boolean;
	register: any;
	handleSubmit: any;
	errors: any;
	loadClient: boolean;
	emailClient: string;
	setLoadClient: any;
	setEmailClient: any;
	trigger?: (a?: string) => any;
	getFormValues: any;
	nextStep?: () => any;
	previousStep?: () => any;
	setCityName: any;
	setCountryName: any;
	catalogueId: string;
	setValue: any;
	showModal?: boolean;
};

const AnddressInfo: FunctionComponent<AnddressInfoProps> = ({
	color,
	isValidForm = false,
	getFormValues,
	register,
	handleSubmit,
	errors,
	trigger = () => {},
	loadClient,
	emailClient,
	setLoadClient,
	catalogueId,
	setEmailClient,
	nextStep = () => {},
	previousStep = () => {},
	successInfo,
	setCityName,
	setCountryName,
	setValue,
	showModal = false,
}) => {
	const homeState: HomeStateType = useSelector(
		(state: RootState) => state.home
	);
	const elogisticaState: any = useSelector(
		(state: RootState) => state.elogistica
	);
	const cityState: any = useSelector((state: RootState) => state.city);
	const countryState: any = useSelector((state: RootState) => state.country);
	const shoppingCartState: ShoppingCartStateType = useSelector(
		(state: RootState) => state.shoppingCart
	);
	const shippingDetailsState: any = useSelector(
		(state: RootState) => state.shippingDetails
	);
	// Datos que prellenan el formulario en el flujo de Marca Blanca (respaldo:
	// mandan los del email si existen).
	const marcaBlancaState = useSelector((state: RootState) => state.marcaBlanca);
	const whiteMarkClient = marcaBlancaState.client;
	const dispatch = useDispatch();
	const { idCart }: any = useParams();
	const { width } = useView();
	const [colorEmptyErrors, setColorEmptyErrors] = useState("#c4c4c4");
	const [productHasProvider, setProductHasProvider] = useState(false);
	const [hasSubmitted, setHasSubmitted] = useState(false);
	// Marca Blanca: confirmación de dirección antes de avanzar al pago.
	const [showAddressConfirm, setShowAddressConfirm] = useState(false);
	// Marca Blanca: aviso cuando los datos precargados fueron manipulados.
	const [showTamperModal, setShowTamperModal] = useState(false);

	const onSubmit = () => {
		setHasSubmitted(true);
	};
	let isMobile = false;
	if (width < 992) {
		isMobile = true;
	}
	const history = useHistory();

	const StyledButton = withStyles({
		root: {
			borderTopLeftRadius: 0,
			borderBottomLeftRadius: 0,
			borderTopRightRadius: 10,
			borderBottomRightRadius: 10,
			display: "block !important",
			height: "46px",
			background: homeState.color,
			color: "#fff",
			fontWeight: 600,
			textTransform: "capitalize",
		},
	})(Button);

	const handleNameInput = (e: any) => {
		let patt = new RegExp(/^[A-Za-z áéíóú]+$/i);
		let res = patt.test(e.key);
		if (!res) {
			e.preventDefault();
		}
	};

	const handleDocumentInput = (e: any) => {
		const isNIT = getFormValues().documentType === 'NIT';
		if (isNIT && e.key === '-') return;
		let patt = new RegExp(/^([0-9]*)$/i);
		let patt2 = new RegExp(/^[A-Za-z]+$/i);
		let res = patt.test(e.key);
		let res2 = patt2.test(e.key);
		if (!res && !res2) {
			e.preventDefault();
		}
	};

	const handlePhoneInput = (e: any) => {
		let patt = new RegExp(/^([0-9]*)$/i);
		let res = patt.test(e.key);
		if (!res) {
			if (
				e.keyCode === 8 ||
				e.keyCode === 46 ||
				e.keyCode === 37 ||
				e.keyCode === 39
			) {
				return;
			}
			e.preventDefault();
		}
	};

	type dataType = {
		keyCode: number;
		preventDefault: Function;
		key: string;
	};

	const handleDetailsInput = (e: dataType) => {
		var patt = new RegExp(/^.{1,35}$/i);
		var res = patt.test(e.key);
		if (!res) {
			e.preventDefault();
		}
	};



	useEffect(() => {
		if (!shippingDetailsState.infoCompleted) {
			if (
				cityState.cities.length === 0 ||
				countryState.countries.length === 0
			) {
				dispatch(handleGetCountries(path));
				dispatch(handleGetCities(path));
			}
		} else {
			setSelectedCountry(shippingDetailsState.country);
			setSelectCity({
				codigoDane: shippingDetailsState.codeDane,
				nombre: shippingDetailsState.city,
				departamento: shippingDetailsState.departament,
			});
			setSelectedDepartament(shippingDetailsState.departament);
		}
		dispatch(
			setRoute({
				route: "/",
				routeName: language[homeState.default_language]["shoppingCart"],
			})
		);
	}, [dispatch]);

	useEffect(() => {
		if (shoppingCartState.id !== 0 || idCart !== 0) {
			window.history.replaceState(
				{ id: idCart },
				homeState.catalogueName,
				`/vende/${homeState.catalogueUrlName}/carrito/${idCart}`
			);
		} else if (shoppingCartState.id === 0 && idCart.toStrign().length > 1) {
			window.history.replaceState(
				{ id: idCart },
				homeState.catalogueName,
				`/vende/${homeState.catalogueUrlName}/carrito/empty`
			);
		}
	}, [homeState.catalogueName, idCart, shoppingCartState.id]);

	let countries = useRef<any>();
	let departaments = useRef<any>();
	let cities = useRef<any>();

	const [selectCity, setSelectCity] = useState({
		codigoDane: 0,
		nombre: language[homeState.default_language]["city"],
		departamento: language[homeState.default_language]["province"],
	});
	const [selectedDepartament, setSelectedDepartament] = useState(
		language[homeState.default_language]["province"]
	);
	const [selectedCountry, setSelectedCountry] = useState(
		shippingDetailsState.country
	);

	const [selecDepartament, setSelecDepartament] = useState([]);
	const [selectCountry, setSelectCountry] = useState([]);
	const [selCity, setSelCity] = useState([]);
	const [alertShipping, setAlertShipping] = useState(false);
	const [tipoDocumento, setTipoDocumento] = useState(shippingDetailsState.documentType || '');
	const { documentTypes } = useDocumentTypes();
	// Marca Blanca entrega el id del documento; el select usa el `code`.
	const whiteMarkDocumentType = whiteMarkClient?.documentTypeId
		? documentTypes.find(
				(dt) => Number(dt.id) === Number(whiteMarkClient.documentTypeId)
		  )?.code
		: undefined;

	// En Marca Blanca los campos precargados no se editan (inputs readOnly,
	// selects disabled).
	const whiteMarkLocked = !!whiteMarkClient;

	// Valores esperados de los selects en Marca Blanca. Se derivan solo de Redux
	const whiteMarkExpectedSelects = useMemo(
		() => ({
			departament:
				shippingDetailsState.departament ||
				(whiteMarkClient?.department
					? formatNameCity(whiteMarkClient.department)
					: ""),
			city:
				shippingDetailsState.city ||
				(whiteMarkClient?.city ? formatNameCity(whiteMarkClient.city) : ""),
			codeDane: shippingDetailsState.codeDane || whiteMarkClient?.codeDane || "",
			documentType: shippingDetailsState.documentType || whiteMarkDocumentType || "",
			country: shippingDetailsState.country || (whiteMarkClient ? "CO" : ""),
		}),
		[shippingDetailsState, whiteMarkClient, whiteMarkDocumentType]
	);

	// Marca Blanca: 10px de separación debajo de cada input.
	const whiteMarkFieldSpacing = whiteMarkLocked
		? { marginBottom: "20px" }
		: undefined;

	const whiteMarkFieldSpacingBottom = whiteMarkLocked
		? "shipping-info-footer-buttons-white-mark"
		: "shipping-info_footer-buttons";
	
	const hasDelivery = () => {
		return homeState.epaycoDeliveryProvider || homeState.providerDelivery;
	};

	const changeCity = (codigoDane: any) => {
		if (productHasProvider && codigoDane != selectCity.codigoDane) {
			const city = elogisticaState.cities.find(
				(item: any) => item.codigo_dane === codigoDane
			);
			if (city !== undefined) {
				setSelectCity({ ...city, codigoDane: city.codigo_dane });
			} else {
				setSelectCity({
					codigoDane: 0,
					nombre: language[homeState.default_language]["city"],
					departamento: language[homeState.default_language]["province"],
				});
			}
		} else if (!productHasProvider) {
			const city = cityState.cities.find(
				(item: any) => item.dane === codigoDane
			);
			if (city) {
				setSelectCity({
					...city,
					codigoDane: city.dane,
					codigo_dane: city.dane,
					nombre: city.name,
					departamento: city.departmentName,
				});
			} else {
				setSelectCity({
					codigoDane: 0,
					nombre: language[homeState.default_language]["city"],
					departamento: language[homeState.default_language]["province"],
				});
			}
		}
	};

	useEffect(() => {
		loadData();
		setSelectedDepartament(
			shippingDetailsState.departament !== ""
				? shippingDetailsState.departament
				: formatNameCity(elogisticaState.selectedCity.departamento)
		);
		changeCity(
			shippingDetailsState.codeDane !== ""
				? shippingDetailsState.codeDane
				: elogisticaState.selectedCity.codigoDane
		);
	}, [elogisticaState.departaments, elogisticaState.cities]);

	useEffect(() => {
		if (selectCity.codigoDane !== 0 && productHasProvider) {
			setSelectedDepartament(
				formatNameCity(elogisticaState.selectedCity.departamento)
			);
			if (!alertShipping) {
				changeCity(elogisticaState.selectedCity.codigoDane);
			}
			setAlertShipping(false);
			if (
				!elogisticaState.CityChangeModalAlert &&
				selectCity.codigoDane !== elogisticaState.selectedCity.codigoDane
			) {
				dispatch(handleToggleCityChangeModalAlert());
			}
		} else if (productHasProvider) {
			changeCity(elogisticaState.selectedCity.codigoDane);
		}
	}, [elogisticaState.selectedCity.codigoDane, productHasProvider]);

	useEffect(() => {
		if (
			productHasProvider &&
			selectCity.codigoDane !== 0 &&
			elogisticaState.selectedCity.codigoDane !== selectCity.codigoDane
		) {
			dispatch(handleOnchangeDefaultCity(selectCity));
			dispatch(handleToggleCityChangeModalAlert());
		}
		if (emailClient.length > 0 && loadClient) {
			trigger();
		}
	}, [selectCity]);

	useEffect(() => {
		if (selectCity.codigoDane === 0) {
			setSelectCity({
				codigoDane: 0,
				nombre: language[homeState.default_language]["city"],
				departamento: language[homeState.default_language]["province"],
			});
		}
		const isDepartamentPlaceholder = Object.values(language).some(
			(lang: any) => lang["province"] === selectedDepartament
		);
		if (isDepartamentPlaceholder) {
			setSelectedDepartament(language[homeState.default_language]["province"]);
		}
	}, [homeState.default_language]);

	const loadCountries = () => {
		if (selectCountry.length === 0) {
			let countriesArray = countryState.countries;
			if (
				countriesArray.length > 0 &&
				countriesArray[0].id !== language[homeState.default_language]["country"]
			) {
				countriesArray.unshift({
					id: language[homeState.default_language]["country"],
					name: language[homeState.default_language]["country"],
					title: language[homeState.default_language]["country"],
				});
			}

			countries.current = countriesArray.map((el: any) => (
				<option key={`${el.id}${uuid()}`} value={el.name}>
					{el.title}
				</option>
			));

			setSelectCountry(countries.current);
		}
	};

	const handleMappingOptionDeparment = (departamentsArray: any) => {
		if (
			departamentsArray.length > 0 &&
			departamentsArray[0].value !==
				language[homeState.default_language]["province"]
		) {
			departamentsArray.unshift({
				value: language[homeState.default_language]["province"],
				name: language[homeState.default_language]["province"],
			});
		}
		departaments.current = departamentsArray.map((el: any) => (
			<option key={`${el.value}${uuid()}`}>{formatNameCity(el.name)}</option>
		));
		setSelecDepartament(departaments.current);
	};

	const handleMappingOptionCity = (citiesArray: any) => {
		if (
			citiesArray.length > 0 &&
			citiesArray[0].nombre !== language[homeState.default_language]["city"]
		) {
			citiesArray.unshift({
				codigo_dane: 0,
				nombre: language[homeState.default_language]["city"],
				departamento: selectedDepartament,
			});
		} else if (citiesArray.length > 0) {
			citiesArray[0] = {
				codigo_dane: 0,
				nombre: language[homeState.default_language]["city"],
				departamento: selectedDepartament,
			};
		}
		cities.current = citiesArray
			.filter(
				(filter: any) =>
					filter.departamento.toUpperCase() ===
					selectedDepartament.toUpperCase()
			)
			.map((el: any) => {
				return (
					<option value={el.codigo_dane} key={`${el.codigo_dane}${uuid()}`}>
						{formatNameCity(el.nombre)}
					</option>
				);
			});
		setSelCity(cities.current);
		if (productHasProvider && elogisticaState.CityChangeModalAlert) {
			dispatch(handleOnchangeDefaultCity(selectCity));
		}
	};

	useEffect(() => {
		if (productHasProvider) {
			let departamentsArray = elogisticaState.departaments;
			handleMappingOptionDeparment(
				departamentsArray.map((item: any) => {
					return { value: item, name: item };
				})
			);

			let citiesArray = elogisticaState.cities;
			handleMappingOptionCity(citiesArray);
		}
	}, [
		selectedDepartament,
		elogisticaState.departaments,
		elogisticaState.cities,
		selectCity,
		productHasProvider,
		homeState.default_language,
	]);

	useEffect(() => {
		loadCountries();
		if (!productHasProvider) {
			let departamentsArray = cityState.cities.map(
				(item: any) => item.departmentName.trim()
			);
			departamentsArray = departamentsArray
				.filter(
					(value: any, index: any, self: any) => self.indexOf(value) === index
				)
				.map((el: any) => {
					return {
						value: el,
						name: el,
					};
				});
			handleMappingOptionDeparment(departamentsArray);

			let citiesArray = cityState.cities.map((item: any) => {
				return {
					...item,
					codigo_dane: item.dane,
					nombre: item.name,
					departamento: item.departmentName.trim(),
				};
			});
			handleMappingOptionCity(citiesArray);
		}
	}, [
		countryState.countries,
		cityState.cities,
		productHasProvider,
		selectedDepartament,
		selectCity,
		homeState.default_language,
	]);

	useEffect(() => {
		if (selectedCountry !== "País") {
			departaments.current = [
				<option key={language[homeState.default_language]["province"]}>
					{language[homeState.default_language]["province"]}
				</option>,
			];
			setSelecDepartament(departaments.current);
			if (
				(cityState.cities.length > 0 &&
					cityState.cities[0].country_code !== selectedCountry) ||
				cityState.cities.length === 0
			) {
				dispatch(handleGetCities(path, selectedCountry));
			}
		}
	}, [selectedCountry]);

	const loadData = () => {
		if (elogisticaState.departaments.length === 0) {
			dispatch(handleLoadDepartaments());
		}
		if (elogisticaState.cities.length === 0) {
			dispatch(handleLoadCities());
		}
	};

	//End Elogistica services

	useEffect(() => {
		if (shoppingCartState.id !== idCart && idCart !== 0 && idCart !== "empty") {
			dispatch(
				handleIdentifyShoppingCart(
					idCart,
					`${domain}/vende/${homeState.catalogueUrlName}`,
					window.location,
					[],
					homeState.default_language
				)
			);
		}
	}, [dispatch, homeState.catalogueName, idCart]);

	const [authorize, setAuthorize] = useState(false);
	useEffect(() => {
		let productArr = shoppingCartState.cartInfo;
		if (
			productArr.filter(
				(product: any) => product.productData.epaycoDeliveryProvider === true
			).length > 0
		) {
			setProductHasProvider(true);
		} else {
			setProductHasProvider(false);
		}
		setAuthorize(shippingDetailsState.saveInfoShipping);
	}, [shoppingCartState.cartInfo]);

	const handleAuthorizeChange = () => {
		if (loadClient) {
			trigger();
			dispatch(
				termsConditions({
					terms: false,
					conditions: false,
					saveInfoShipping: !authorize,
				})
			);
			setAuthorize((prev) => !prev);
		}
	};

	const validaEmail = (value: string) => {
		let emailRegex =
			/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		return emailRegex.test(value);
	};

	const handleNextStep = async () => {

		trigger().then(()=>{
			setHasSubmitted(true);
			let isValid = getIsDisabledPaymentButton();

			if(isValid)
			{
				nextStep();

			}
		});
	};

	const handlePreviousStep = async () => {
		previousStep();
	};

	// Verifica que los datos precargados sigan siendo los del comercio validado.
	const whiteMarkDataIsIntact = (): boolean => {
    if (!whiteMarkClient) return true;

    const values = getFormValues();
    const norm = (value: any) => String(value ?? "").trim();
    const matches = (formValue: any, expected: any) =>
      norm(formValue).toLowerCase() === norm(expected).toLowerCase();
    const selectMatches = (formValue: any, expected: any) =>
      norm(formValue) === "" || norm(expected) === "" || matches(formValue, expected);

    return (
			norm(values.name) === norm(whiteMarkClient.firstName) &&
			norm(values.lastname) === norm(whiteMarkClient.lastName) &&
			norm(values.document) === norm(marcaBlancaState.documentNumber) &&
			matches(emailClient, whiteMarkClient.email) &&
			norm(values.phone) === norm(whiteMarkClient.mobile) &&
			norm(values.address) === norm(whiteMarkClient.addressDetail) &&
			selectMatches(values.documentType, whiteMarkExpectedSelects.documentType) &&
			selectMatches(values.country, whiteMarkExpectedSelects.country) &&
			selectMatches(values.departament, whiteMarkExpectedSelects.departament) &&
			// El <select> de ciudad guarda el código DANE, no el nombre.
			selectMatches(values.city, whiteMarkExpectedSelects.codeDane)
		);
	};


	const handleContinue = () => {
		if (whiteMarkLocked) {
			// Datos manipulados respecto a la validación: se rechaza el avance.
			if (!whiteMarkDataIsIntact()) {
				setShowTamperModal(true);
				return;
			}
			setShowAddressConfirm(true);
		} else {
			handleNextStep();
		}
	};

	const handleAddressConfirmAccept = () => {
		setShowAddressConfirm(false);
		// Revalida al confirmar, por si se manipuló el DOM con el modal abierto.
		if (whiteMarkLocked && !whiteMarkDataIsIntact()) {
			setShowTamperModal(true);
			return;
		}
		handleNextStep();
	};

	const handleAddressConfirmRequestChange = () => {
		setShowAddressConfirm(false);
		window.open(
			config.epaycoSupportTicketUrl,
			"_blank",
			"noopener,noreferrer"
		);
		window.location.href = `/vende/${homeState.catalogueUrlName}`;
	};

	const handleSearchClient = async (emailClient: string) => {
		if (emailClient.length > 0 && validaEmail(emailClient)) {
			setLoadClient(true);
			dispatch(handleResetDetails());
			dispatch(handleLoadingInfo(true));

			dispatch(handleSearchBuyer(emailClient, path, catalogueId, false));
		}
	};

	const showError = (field: string) => {
		const clientDetailsLoaded = shippingDetailsState.loading;

		if (field === "country") {
			return !clientDetailsLoaded && selectedCountry.length === 0;
		}
		if (field === "departament") {
			return (
				!clientDetailsLoaded &&
				((selectedDepartament.length === 0) ||
					(selectedDepartament === "Departamento"))
			);
		}
		if (field === "city") {
			return !clientDetailsLoaded && (selectCity.codigoDane === 0 || (selectCity.codigoDane as any) === '');
		}

		return false;
	};

	const getIsDisabledPaymentButton = () => {
		const hasErrorDepartament = showError("departament");
		const hasErrorCity = showError("city");
		const hasErrorCountry = showError("country");
		const hasErrorPhone = (getFormValues().phone)?(getFormValues().phone.length<10)?true:false:true;

		return (
			!(getFormValues().name =="" ||
			getFormValues().lastname =="" ||
			getFormValues().documentType =="" ||
			getFormValues().document =="" ||
			getFormValues().address =="" ||
			getFormValues().phone ==""  ||
			hasErrorPhone == true ||
			hasErrorCountry== true ||
			hasErrorDepartament == true ||
			hasErrorCity== true
			));
	};

	useEffect(() => {
		const { departament, city, codeDane, documentType } =
			whiteMarkExpectedSelects;

		setSelectedCountry(shippingDetailsState.country);
		setCountryName(
			["CO", "co"].includes(shippingDetailsState.country) ? "Colombia" : ""
		);
		setSelectedDepartament(departament === "Bogotá DC" ? "Bogotá Dc" : departament);
		setValue("departament", departament);
		setValue("city", codeDane);
		setSelectCity({
			codigoDane: codeDane,
			nombre: city,
			departamento: departament,
		});
		setCityName(city);
		if (documentType) {
			setValue("documentType", documentType);
			setTipoDocumento(documentType);
		}
		// `documentTypes` en deps: el code del documento se resuelve al cargarla.
	}, [shippingDetailsState.documentId, whiteMarkClient, documentTypes]);

	// Marca Blanca: precarga el email solo si está vacío, sin pisar lo tipeado.
	useEffect(() => {
		if (!emailClient && whiteMarkClient?.email) {
			setEmailClient(whiteMarkClient.email);
		}
	}, [whiteMarkClient]);

	// Marca Blanca: habilita el formulario sin la consulta por email (oculta el
	// botón de confirmar correo y activa "Continuar").
	useEffect(() => {
		if (whiteMarkClient) {
			setLoadClient(true);
		}
	}, [whiteMarkClient]);

	return (
		<AddresInfoContainer showModal={showModal}>
			<div className={"address-info-container"}>
				<form onSubmit={handleSubmit(onSubmit)}>
					<MainHeadingForm>
						<TitleSummaryCart
							color={homeState.color}
							isEmpty={shoppingCartState.cartInfo.length <= 0}
						>
							{language[homeState.default_language]["infoContact"]}
						</TitleSummaryCart>
					</MainHeadingForm>
					<FormContainer>
						<div></div>
						<SecondParragraph color={homeState.color} opacity={false}>
							<span>1</span>
							{language[homeState.default_language]["inputEmail"]}
						</SecondParragraph>

						<ContainerInputEmail widthProps={!loadClient ? "80%" : "100%"}>
							<div>
								<StyledTextField
									variant="outlined"
									placeholder="example@email.com"
									key="email"
									value={emailClient}
									loadClient={loadClient}
									disabled={loadClient}
									onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
										setEmailClient(event.target.value);
										setLoadClient(false);
									}}
									InputProps={{
										inputProps: {
											"data-testid": "input",
										},
										startAdornment: (
											<InputAdornment position="start" key="userIcon">
												<AccountCircle htmlColor={homeState.color} />
											</InputAdornment>
										),
										endAdornment: (
											<>
												{/* Marca Blanca: sin ícono de editar, el correo queda fijo. */}
												{loadClient && !whiteMarkClient ? (
													<InputAdornment position="end" key="editIcon">
														<EditOutlinedIcon
															htmlColor={homeState.color}
															style={{ cursor: "pointer" }}
															onClick={() => setLoadClient(false)}
														/>
													</InputAdornment>
												) : (
													<></>
												)}
											</>
										),
									}}
								/>
							</div>
							{!loadClient && (
								<div>
									<StyledButton
										variant="contained"
										key="buttomEmail"
										disableElevation
										onClick={() => handleSearchClient(emailClient)}
										disabled={!validaEmail(emailClient)}
									>
										{language[homeState.default_language]["continue"]}
									</StyledButton>
								</div>
							)}
						</ContainerInputEmail>

						<SecondParragraph color={homeState.color} opacity={!loadClient}>
							<span>2</span>
							{language[homeState.default_language]["completedInfo"]}
						</SecondParragraph>
						{shippingDetailsState.loading ? (
							<LoadContainer>
								<Spinner color={homeState.color} />
							</LoadContainer>
						) : (
							<>
								<SecondDivForm>
									<NameInput
										color={
											loadClient && errors.name
												? "#ff0000"
												: width > 992
												? "#c4c4c4"
												: colorEmptyErrors
										}
										placeholder={language[homeState.default_language]["name"]}
										style={whiteMarkFieldSpacing}
										name="name"
										maxLength={15}
										onKeyDown={handleNameInput}
										onChange={() => trigger("name")}
										defaultValue={
											shippingDetailsState?.firstName ||
											whiteMarkClient?.firstName ||
											shoppingCartState.contactName ||
											""
										}
										disabled={!loadClient}
										readOnly={whiteMarkLocked}
										ref={register({
											required: true,
											minLength: 1,
											pattern: /^[A-Za-z áéíóúü]+$/i,
										})}
									/>

									<NameInput
										color={
											loadClient && errors.lastname
												? "#ff0000"
												: width > 992
												? "#c4c4c4"
												: colorEmptyErrors
										}
										placeholder={
											language[homeState.default_language]["lastname"]
										}
										style={whiteMarkFieldSpacing}
										name="lastname"
										maxLength={15}
										onKeyDown={handleNameInput}
										onChange={() => trigger("lastname")}
										defaultValue={
											shippingDetailsState?.lastName ||
											whiteMarkClient?.lastName ||
											shoppingCartState.contactLastname ||
											""
										}
										disabled={!loadClient}
										readOnly={whiteMarkLocked}
										ref={register({
											required: true,
											minLength: 1,
											pattern: /^[A-Za-z áéíóúü]+$/i,
										})}
									/>
								</SecondDivForm>
								<DivForSpan1>
									{loadClient && errors.name && isMobile && (
										<span style={{ display: "flex" }} className="fontSizeSmall">
											{language[homeState.default_language]["inputName"]}
										</span>
									)}
									{loadClient && errors.name && !isMobile && (
										<SpanOne className="fontSizeSmall">
											{language[homeState.default_language]["inputName"]}
										</SpanOne>
									)}
									{!loadClient && errors.name && !isMobile && (
										<SpanOne> </SpanOne>
									)}
									{loadClient && errors.lastname && isMobile && (
										<span style={{ display: "flex" }} className="fontSizeSmall">
											{language[homeState.default_language]["inputName"]}
										</span>
									)}
									{loadClient && errors.lastname && !isMobile && (
										<SpanTwo className="fontSizeSmall">
											{language[homeState.default_language]["inputLastname"]}
										</SpanTwo>
									)}
								</DivForSpan1>
								
								<SecondDivForm>
									<div style={{ flex: "0 0 35%", marginRight: isMobile ? 0 : 20 }}>
										{/* Marca Blanca: sin label sobre el campo. */}
										{!whiteMarkLocked && (
											<label style={{
												display: "block",
												fontSize: "14px",
												fontFamily: "'Segoe UI', 'Open Sans', Roboto, sans-serif",
												color: "#000",
												marginBottom: "5px",
												marginTop: "20px",
												fontWeight: 600,
											}}>
												{language[homeState.default_language]["typeDocumentLabel"]}
												<span style={{ color: "#E11417" }}>*</span>
											</label>
										)}
										<ThirdSelectForm
											style={{ width: "100%", marginTop: 0 }}
											color={
												hasSubmitted && errors.documentType
													? "#ff0000"
													: width > 992
													? "#c4c4c4"
													: colorEmptyErrors
											}
											name="documentType"
											disabled={!loadClient || whiteMarkLocked}
											ref={register({ required: true })}
											value={tipoDocumento}
											onChange={(e: any) => {
												setTipoDocumento(e.target.value);
												setValue("documentType", e.target.value);
												setValue("document", "");
												trigger("documentType");
											}}
										>
											<option value="">{language[homeState.default_language]["inputSelect"]}</option>
											{documentTypes.map((dt) => (
												<option key={dt.id} value={dt.code}>{dt.name}</option>
											))}
										</ThirdSelectForm>
									</div>
									<div style={{ flex: 1 }}>
										{/* Marca Blanca: sin label sobre el campo. */}
										{!whiteMarkLocked && (
											<label style={{
												display: "block",
												fontSize: "14px",
												fontFamily: "'Segoe UI', 'Open Sans', Roboto, sans-serif",
												color: "#000",
												marginBottom: "5px",
												marginTop: "20px",
												fontWeight: 600,
											}}>
												{language[homeState.default_language]["documentNumberLabel"]}
												<span style={{ color: "#E11417" }}>*</span>
											</label>
										)}
										<DetailsForm
											style={{ width: "100%", marginTop: 0, boxSizing: "border-box", ...whiteMarkFieldSpacing }}
											name="document"
											onKeyDown={handleDocumentInput}
											maxLength={25}
											className={
												loadClient && errors.document ? "errorInput" : "noError"
											}
											placeholder={language[homeState.default_language]["nameAveonline"]}
											onChange={() => trigger("document")}
											disabled={!loadClient}
											readOnly={whiteMarkLocked}
											color={
												loadClient && errors.document
													? "#ff0000"
													: width > 992
													? "#c4c4c4"
													: colorEmptyErrors
											}
											defaultValue={
											shippingDetailsState?.documentId ||
											marcaBlancaState.documentNumber ||
											""
										}
											ref={register({
												required: true,
												minLength: 1,
												maxLength: 35,
												validate: (value: string) => {
													// `tipoDocumento` is the source of truth for the controlled select and is
													// hydrated from redux on mount; getFormValues().documentType can momentarily
													// be empty when this validate runs during remount (step 3 → step 2),
													// which caused the NIT hyphen to fail the CC-only regex.
													const currentDocType = tipoDocumento || getFormValues().documentType;
													if (currentDocType === 'NIT') {
														return /^[0-9]+-[0-9]$/.test(value) || language[homeState.default_language]["documentNit"];
													}
													return /^[0-9]+$/.test(value) || language[homeState.default_language]["documentNumber"];
												},
											})}
										/>
									</div>
                </SecondDivForm>
                {!whiteMarkLocked && (
  								<DivForSpan1>
 									{hasSubmitted && errors.documentType && isMobile && (
  										<span style={{ display: "flex" }} className="fontSizeSmall">
 											{language[homeState.default_language]["documentTypeRequired"]}
  										</span>
 									)}
 									{hasSubmitted && errors.documentType && !isMobile && (
  										<SpanOne className="fontSizeSmall">
 											{language[homeState.default_language]["documentTypeRequired"]}
  										</SpanOne>
 									)}
 									{!errors.documentType && !isMobile && <SpanOne>&nbsp;</SpanOne>}
 									{loadClient && errors.document && isMobile && (
  										<span style={{ display: "flex" }} className="fontSizeSmall">
 											{errors.document.type === 'validate'
  												? errors.document.message
  												: language[homeState.default_language]["inputNumber"]}
  										</span>
 									)}
 									{loadClient && errors.document && !isMobile && (
  										<SpanTwo className="fontSizeSmall">
 											{errors.document.type === 'validate'
  												? errors.document.message
  												: language[homeState.default_language]["inputNumber"]}
  										</SpanTwo>
 									)}
  								</DivForSpan1>
                )}  

								<DetailsForm
									style={whiteMarkFieldSpacing}
									name="address"
									onKeyDown={handleDetailsInput}
									maxLength={35}
									className={
										loadClient && errors.address ? "errorInput" : "noError"
									}
									placeholder={language[homeState.default_language]["address"]}
									onChange={() => trigger("address")}
									color={
										loadClient && errors.address
											? "#ff0000"
											: width > 992
											? "#c4c4c4"
											: colorEmptyErrors
									}
									defaultValue={
										shippingDetailsState?.address1 ||
										whiteMarkClient?.addressDetail ||
										""
									}
									disabled={!loadClient}
									readOnly={whiteMarkLocked}
									ref={register({
										required: true,
										minLength: 1,
										maxLength: 35,
									})}
								/>
								<FifthDivForm>
									{loadClient && errors.address && isMobile && (
										<span style={{ display: "flex" }} className="fontSizeSmall">
											{language[homeState.default_language]["inputAddress"]}
										</span>
									)}
									{loadClient && errors.address && !isMobile && (
										<SpanOne className="fontSizeSmall">
											{language[homeState.default_language]["inputAddress"]}
										</SpanOne>
									)}
								</FifthDivForm>

								<DetailsForm
									style={whiteMarkFieldSpacing}
									name="optional1"
									onKeyDown={handleDetailsInput}
									maxLength={35}
									className={
										loadClient && errors.optional1 ? "errorInput" : "noError"
									}
									placeholder={
										language[homeState.default_language]["otherAdress"]
									}
									defaultValue={shippingDetailsState?.address2}
									onChange={() => trigger("optional1")}
									disabled={!loadClient}
									readOnly={whiteMarkLocked}
									ref={register({ minLength: 1, maxLength: 35 })}
								/>

								{homeState.epaycoDeliveryProvider && (
									<CityChangeAlert color={homeState.color} />
								)}
								{elogisticaState.CityChangeAlert ? (
									<>
										<Stack
											sx={{ width: "99%", border: "2px solid #F5E414" }}
											spacing={2}
											style={{ textAlign: "left" }}
										>
											<Alert
												icon={
													<CustomIcon
														size="26px"
														color={""}
														hover={false}
														type="warning"
													/>
												}
												severity="warning"
												color="warning"
												style={{ fontSize: "13px", fontFamily: "Open Sans" }}
												action={
													<IconButton
														aria-label="close"
														color="inherit"
														size="small"
														onClick={() => {
															dispatch(handleToggleCityChangeAlert());
														}}
														style={{ display: "inline", background: "none" }}
													>
														<Close onClick={() => ""} color={homeState.color} />
													</IconButton>
												}
											>
												<p style={{ color: "#000" }}>
													{
														language[homeState.default_language][
															"menssageChangeInfo"
														]
													}
												</p>
											</Alert>
										</Stack>
									</>
								) : (
									<></>
								)}

								<CountrySelectForm
									style={whiteMarkFieldSpacing}
									color={
										showError("country")
											? "#ff0000"
											: width > 992
											? "#c4c4c4"
											: colorEmptyErrors
									}
									name="country"
									disabled={!loadClient || whiteMarkLocked}
									ref={register({
										required: true,
									})}
									value={productHasProvider ? "CO" : selectedCountry}
									defaultValue={shippingDetailsState?.country}
									onChange={(e) => {
										if (!productHasProvider) {
											trigger("country");
											setSelectedCountry(e.target.value);
											const nameCountry = countryState.countries.find(
												(itemContry: any) => itemContry.name === e.target.value
											);
											setCountryName(nameCountry ? nameCountry.title : "");
											setSelectedDepartament(
												language[homeState.default_language]["province"]
											);
											changeCity(language[homeState.default_language]["city"]);
											setSelectCity({
												codigoDane: 0,
												nombre: language[homeState.default_language]["city"],
												departamento:
													language[homeState.default_language]["province"],
											});
										}
									}}
								>
									{selectCountry}
								</CountrySelectForm>
								<FifthDivForm>
									{showError("country") && isMobile && (
										<span style={{ display: "flex" }} className="fontSizeSmall">
											{language[homeState.default_language]["selectedContry"]}
										</span>
									)}
									{showError("country") && !isMobile && (
										<SpanOne className="fontSizeSmall">
											{language[homeState.default_language]["selectedContry"]}
										</SpanOne>
									)}
								</FifthDivForm>

								<SecondDivForm>
									<FirstSelectForm
										color={
											hasSubmitted && showError("departament")
												? "#ff0000"
												: width > 992
												? "#c4c4c4"
												: colorEmptyErrors
										}
										style={whiteMarkFieldSpacing}
										name="departament"
										disabled={!loadClient || whiteMarkLocked}
										ref={register({
											required: true,
										})}
										value={selectedDepartament}
										defaultValue={shippingDetailsState?.departament}
										onChange={(e) => {
											trigger("departament");
											if (
												e.target.value ===
												language[homeState.default_language]["province"]
											) {
												setSelectedDepartament(
													formatNameCity(
														elogisticaState.selectedCity.departamento
													)
												);
												changeCity(elogisticaState.selectedCity.codigoDane);
											} else {
												setSelectedDepartament(e.target.value);
												setSelectCity({
													codigoDane: 0,
													nombre: language[homeState.default_language]["city"],
													departamento:
														language[homeState.default_language]["province"],
												});
											}
										}}
									>
										{selecDepartament}
									</FirstSelectForm>
									<SecondSelectForm
										color={
											hasSubmitted && showError("city")
												? "#ff0000"
												: width > 992
												? "#c4c4c4"
												: colorEmptyErrors
										}
										style={whiteMarkFieldSpacing}
										name="city"
										disabled={!loadClient || whiteMarkLocked}
										ref={register({
											required: true,
										})}
										onChange={(e) => {
											trigger();
											setCityName(
												productHasProvider
													? elogisticaState.cities.find(
															(item: any) => item.dane == e.target.value
													  )?.nombre
													: cityState.cities.find(
															(item: any) => item.dane == e.target.value
													  )?.name
											);
											changeCity(e.target.value);
											if (productHasProvider) {
												setAlertShipping(true);
											}
										}}
										defaultValue={shippingDetailsState.codeDane}
										value={selectCity.codigoDane}
									>
										{selCity}
									</SecondSelectForm>
								</SecondDivForm>

                {!whiteMarkLocked && (
  								<DivForSpan1>
  									{hasSubmitted && showError("departament") && isMobile && (
  										<span style={{ display: "flex" }} className="fontSizeSmall">
  											{language[homeState.default_language]["selectedProvince"]}
  										</span>
  									)}
  									{hasSubmitted && showError("departament") && !isMobile && (
  										<SpanOne className="fontSizeSmall">
  											{language[homeState.default_language]["selectedProvince"]}
  										</SpanOne>
  									)}
  									{!showError("departament") && !isMobile && (
  										<SpanOne>&nbsp;</SpanOne>
  									)}
  									{hasSubmitted && showError("city") && isMobile && (
  										<span style={{ display: "flex" }} className="fontSizeSmall">
  											{language[homeState.default_language]["seletedCity"]}
  										</span>
  									)}
  									{hasSubmitted && showError("city") && !isMobile && (
  										<SpanTwo className="fontSizeSmall">
  											{language[homeState.default_language]["seletedCity"]}
  										</SpanTwo>
  									)}
  								</DivForSpan1>
                  )}

								<PhoneInput
									color={
										loadClient && errors.phone && hasSubmitted
											? "#ff0000"
											: width > 992
											? "#c4c4c4"
											: colorEmptyErrors
									}
									placeholder={language[homeState.default_language]["phone"]}
									name="phone"
									maxLength={15}
									onKeyDown={handlePhoneInput}
									onChange={() => {
										trigger();
									}}
									defaultValue={
										shippingDetailsState?.phone ||
										whiteMarkClient?.mobile ||
										shoppingCartState?.contactPhone ||
										""
									}
									disabled={!loadClient}
									readOnly={whiteMarkLocked}
									ref={register({
										required: true,
										minLength: 10,
										maxLength: 15,
										pattern: /^([0-9]*)$/i,
									})}
								/>
								{loadClient && errors.phone && isMobile && hasSubmitted && (
									<span style={{ display: "flex" }} className="fontSizeSmall">
										{language[homeState.default_language]["phoneInvalid"]}
									</span>
								)}
								{ errors.phone && !isMobile && hasSubmitted && (
									<SpanOne className="fontSizeSmall">
										{language[homeState.default_language]["phoneInvalid"]}
									</SpanOne>
								)}
								{/* Marca Blanca: sin guardar información para próximas compras. */}
								{!whiteMarkLocked && (
									<>
										<ContainerAuthorize disabled={!loadClient}>
											<Checkbox
												checked={authorize}
												color={homeState.color}
												onChange={handleAuthorizeChange}
												disabled={!loadClient}
											/>
											<label>
												{language[homeState.default_language]["saveInfo"]}
											</label>
										</ContainerAuthorize>
										<ContainerNote>
											<InfoIcon htmlColor="#40A8E6" />
											<p>
												{
													language[homeState.default_language][
														"messageAuthorization"
													]
												}
											</p>
										</ContainerNote>
									</>
								)}
							</>
						)}
					</FormContainer>
				</form>

				{!shippingDetailsState.loading && (
					<div className={whiteMarkFieldSpacingBottom}>
						<ReturnLinkContainer className="return-link-container">
							<a
								style={{ cursor: "pointer", color: `${homeState.color}` }}
								onClick={() => handlePreviousStep()}
								className="return-link"
							>
								<ChevronLeftIcon style={{ color: `${homeState.color}` }} />{" "}
								{language[homeState.default_language]["back"]}
							</a>
						</ReturnLinkContainer>

						<div className="shipping-info__pay-button-container">
							<CartPaymentButton
								color={color}
								loading={false}
								onClick={handleContinue}
								disabled={(getIsDisabledPaymentButton()==false && hasSubmitted) || !loadClient}
							>
								{language[homeState.default_language]["continue"]}
							</CartPaymentButton>
							<AddMoreProducts
								language={
									language[homeState.default_language]["addMoreProducts"]
								}
								onClick={() =>
									history.push(`/vende/${homeState.catalogueUrlName}/categories`)
								}
							/>
						</div>
					</div>
				)}
			</div>

			{whiteMarkLocked && (
				<MarcaBlancaAddressConfirmModal
					open={showAddressConfirm}
					color={homeState.color}
					title={language[homeState.default_language]["marcaBlancaAddressConfirmTitle"]}
					descriptionOne={
						language[homeState.default_language]["marcaBlancaAddressConfirmDescOne"]
					}
					descriptionTwo={
						language[homeState.default_language]["marcaBlancaAddressConfirmDescTwo"]
					}
					acceptLabel={
						language[homeState.default_language]["marcaBlancaAddressConfirmAccept"]
					}
					requestChangeLabel={
						language[homeState.default_language][
							"marcaBlancaAddressConfirmRequestChange"
						]
					}
					onAccept={handleAddressConfirmAccept}
					onRequestChange={handleAddressConfirmRequestChange}
					onClose={() => setShowAddressConfirm(false)}
				/>
			)}

			{whiteMarkLocked && (
				<MarcaBlancaTamperModal
					open={showTamperModal}
					color={homeState.color}
					title={language[homeState.default_language]["marcaBlancaTamperTitle"]}
					message={language[homeState.default_language]["marcaBlancaTamperError"]}
					acknowledgeLabel={
						language[homeState.default_language]["marcaBlancaReqAcknowledge"]
					}
					onClose={() => setShowTamperModal(false)}
				/>
			)}
		</AddresInfoContainer>
	);
};

export default AnddressInfo;